/**
 * Emerging Payments API
 * The public API for Emerging Payments.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SSRTextPlacementContentAllOfContentData } from './SSRTextPlacementContentAllOfContentData';
import { HttpFile } from '../http/http';

export class SSRTextPlacementContentAllOf {
    'contentType'?: SSRTextPlacementContentAllOfContentTypeEnum;
    'contentData'?: SSRTextPlacementContentAllOfContentData;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contentType",
            "baseName": "contentType",
            "type": "SSRTextPlacementContentAllOfContentTypeEnum",
            "format": ""
        },
        {
            "name": "contentData",
            "baseName": "contentData",
            "type": "SSRTextPlacementContentAllOfContentData",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SSRTextPlacementContentAllOf.attributeTypeMap;
    }
    
    public constructor() {
    }
}


export type SSRTextPlacementContentAllOfContentTypeEnum = "SSRTextPlacementContent" ;

